import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Sello from "@/components/landing/Sello";
import Servicios from "@/components/landing/Servicios";
import Contacto from "@/components/landing/Contacto";
import Footer from "@/components/landing/Footer";
import { AvisoLegal, Privacidad, Cookies } from "@/pages/Legal";
import Incidencia from "@/pages/Incidencia";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Sello />
        <Servicios />
        <Contacto />
      </main>
      <Footer />
    </>
  );
}


function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const frame = requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    return () => cancelAnimationFrame(frame);
  }, [hash]);

  return null;
}

function App() {
  return (
    <div className="App bg-white text-slate-900 antialiased" data-testid="app-root">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/servicios" element={<Navigate to="/#servicios" replace />} />
          <Route path="/en/services" element={<Navigate to="/#servicios" replace />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/politica-de-privacidad" element={<Privacidad />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/politica-de-cookies" element={<Cookies />} />
          <Route path="/notificar-incidencia" element={<Incidencia />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
